// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none !important;
}
ion-header .toolbar {
  background: white;
  z-index: 999;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
}
@media (max-width: 992px) {
  ion-header .toolbar .logo_icon {
    display: none;
  }
}
ion-header .toolbar ion-icon {
  width: 155px;
  height: 50px;
}
@media (min-width: 991px) {
  ion-header .toolbar ion-icon {
    width: 160px;
    height: 60px;
  }
}
ion-header .toolbar .burger_block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .burger_block .basket_version {
  position: relative;
  display: flex;
  justify-content: center;
}
@media (max-width: 992px) {
  ion-header .toolbar .burger_block .basket_version {
    display: none;
  }
}
ion-header .toolbar .burger_block .basket_version ion-icon {
  width: 35px !important;
  height: 35px !important;
}
ion-header .toolbar .burger_block .basket_version div {
  top: 0px;
  right: 0px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-header .toolbar .burger_block .basket_version div p {
  font-size: 10px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
@media (max-width: 992px) {
  ion-header .toolbar .logo_icon {
    display: none;
  }
}
ion-header .toolbar .back_icon {
  width: 20px !important;
  height: 20px !important;
}
ion-header .toolbar .back-block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .back-block ion-icon {
  margin-right: 5px;
}
ion-header .toolbar .desktop-logo {
  width: 120px !important;
  height: 50px !important;
  margin-left: 30px;
}
@media (max-width: 992px) {
  ion-header .toolbar .desktop-logo {
    display: none;
  }
}
ion-header .toolbar .burger_block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .burger_block .basket_version {
  position: relative;
  display: flex;
  justify-content: center;
  width: 35px;
  height: 35px;
}
@media (max-width: 992px) {
  ion-header .toolbar .burger_block .basket_version {
    display: none;
  }
}
ion-header .toolbar .burger_block .basket_version ion-icon {
  width: 35px !important;
  height: 35px !important;
}
ion-header .toolbar .burger_block .basket_version div {
  top: 0px;
  right: 0px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-header .toolbar .burger_block .basket_version div p {
  font-size: 10px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
ion-header .toolbar .venue_info_block {
  display: flex;
  align-items: flex-start;
  max-width: 70%;
}
ion-header .toolbar .venue_info_block .map_icon {
  width: 20px;
  height: 25px;
  margin-right: 5px;
}
ion-header .toolbar .venue_info_block span {
  padding: 1px 6px;
  background: var(--ion-color-primary);
  color: white;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: 50px;
  font-family: AppFontBold, sans-serif;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block span {
    font-size: 12px;
    padding: 3px 10px;
  }
}
ion-header .toolbar .venue_info_block .venue_info ion-icon {
  width: 11px;
  height: 11px;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block .venue_info ion-icon {
    width: 13px;
    height: 13px;
  }
}
ion-header .toolbar .venue_info_block .venue_info h5 {
  cursor: pointer;
  font-size: 12px;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block .venue_info h5 {
    font-size: 16px;
  }
}
ion-header .toolbar .venue_info_block .venue_info p {
  font-size: 10px;
}
ion-header .categories-block .category-list {
  visibility: visible;
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
ion-header .categories-block .category-list.hide-scroll {
  visibility: hidden;
  opacity: 0;
  height: 0px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list {
    justify-content: center;
  }
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
    padding: 12px 16px !important;
  }
}
ion-header .categories-block .category-list::-webkit-scrollbar {
  display: none;
}
ion-header .categories-block .category-list .line-dotted-block {
  min-width: 20px;
  height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .line-dotted-block {
    height: 112px;
    min-width: 50px;
  }
  ion-header .categories-block .category-list .line-dotted-block ion-img {
    width: 23px;
  }
}
ion-header .categories-block .category-list .category-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }
}
ion-header .categories-block .category-list .category-wrapper .category-name {
  padding-top: 10px;
  font-size: 12px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;
  font-weight: 100;
  margin-bottom: 0px;
  width: 60px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: #979797;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper .category-name {
    width: 100px;
    font-size: 22px;
  }
  ion-header .categories-block .category-list .category-wrapper .category-name.selected {
    color: var(--text-color);
    transition: ease-in-out 0.5s;
  }
}
ion-header .categories-block .category-list .category-wrapper.selected {
  transition: 200ms linear;
}
ion-header .categories-block .category-list .category-wrapper.selected ion-chip {
  opacity: 1;
  background: var(--ion-color-primary);
  height: 80px;
  width: 80px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper.selected ion-chip {
    width: 70px;
    height: 70px;
  }
}
ion-header .categories-block .category-list .category-wrapper.selected ion-chip .border-dotted {
  width: 78px;
  height: 78px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper.selected ion-chip .border-dotted {
    width: 65px;
    height: 65px;
  }
}
ion-header .categories-block .category-list .category-wrapper ion-chip {
  opacity: 1;
  border-radius: 50%;
  padding: 5px;
  background: white;
  text-transform: capitalize;
  flex: 0 0 auto;
  height: 60px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip {
    height: 60px;
    width: 60px;
  }
}
ion-header .categories-block .category-list .category-wrapper ion-chip .category-image {
  width: 80%;
  margin: 0 auto;
}
ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
    height: 55px;
    width: 55px;
  }
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33% - 10px);
    margin: 0 5px 10px;
  }
}

.articles-wrapper {
  padding: 18px 20px 0;
}
@media (min-width: 991px) {
  .articles-wrapper {
    margin: 0 -5px;
    padding: 20px 50px 0;
  }
}

ion-searchbar {
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  --placeholder-color: var(--ion-color-secondary);
  --placeholder-opacity: 1;
  --color: var(--ion-color-secondary);
  --icon-color: var(--ion-color-secondary);
  --border-radius: 0px;
  border-radius: 10px;
  font-size: 14px;
  font-family: Raleway, sans-serif;
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}
.main-row ion-col.hidden {
  visibility: hidden;
  min-height: 0px;
  height: 0px;
  transition: ease-out 1s;
}

app-order-content {
  display: block;
  height: 100%;
  width: 100%;
}

.order-col {
  min-width: 380px;
}

.padding-end {
  padding-right: 11px;
}

ion-footer {
  background: #fff;
  text-transform: uppercase;
}

@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.search-block {
  opacity: 1;
  transition: 1s linear;
}

.hidden {
  opacity: 0;
  display: none !important;
  transition: 1s linear !important;
}

.category-header {
  padding: 20px 20px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
}
@media (min-width: 991px) {
  .category-header {
    padding: 0px 20px 10px;
  }
}
.category-header h3 {
  color: black;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-transform: capitalize;
}
@media (min-width: 991px) {
  .category-header h3 {
    font-size: 27px;
    padding: 0px 30px 0px;
  }
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 100%;
  max-width: 45%;
  min-width: 40%;
  background: #f6f0eb;
  box-shadow: -4px 4px 100px 0px rgba(0, 0, 0, 0.15);
  right: -40%;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px 25px 0px;
  background: white;
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  color: var(--ion-color-black);
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}
.order_basket_block .order_list_row {
  height: calc(95% - 70px);
  display: flex;
}
.order_basket_block .checkout_row {
  width: 100%;
  height: 50%;
  padding: 20px 20px 0px 20px;
}

.filters_section {
  position: fixed;
  bottom: -80%;
  left: 0;
  right: 0;
  background: white;
  overflow: hidden;
  transition: bottom 0.6s ease-in-out;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1);
}
.filters_section.visible {
  bottom: 0%;
  overflow: visible;
}

swiper-container {
  height: 100%;
}
swiper-container swiper-slide {
  height: 100%;
}

.bg-white {
  background: white;
  position: relative;
  padding: 10px 0px;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted2.svg') no-repeat center center/100% 130%;
    height: 26px;
    width: 100%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

ion-spinner {
  color: white;
}

.margin-block {
  margin: 10px 20px 0px;
}
@media (min-width: 991px) {
  .margin-block {
    margin: 0px 40px;
  }
}

.test {
  width: 100%;
  height: 30px;
  position: absolute;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  top: -31px;
}

.items-wrap.padding-bottom {
  padding-bottom: 120%;
}
@media (min-width: 991px) {
  .items-wrap.padding-bottom {
    padding-bottom: 400px;
  }
}

.separator_white_wrapper {
  width: 100%;
  padding: 20px;
}
@media (min-width: 991px) {
  .separator_white_wrapper {
    padding: 20px 50px;
  }
}
.separator_white_wrapper .separator_white {
  height: 14px;
  width: 100%;
  background: url('separator_doted_white.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator_white_wrapper .separator_white {
    background: url('separator_doted2_white.svg') no-repeat center center/100% 130%;
    height: 20px;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator_white_wrapper .separator_white {
    height: 11px;
  }
}

.text_type {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  margin-bottom: 5px;
}
.text_type ion-icon {
  margin-left: 5px;
}

.padding-block {
  padding: 5px 20px;
}

.data-card {
  color: white;
}

.search-results {
  height: 20rem;
  overflow: scroll;
}

.wrapper-scroll {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: auto;
  background: white;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  height: 100px;
}
.wrapper-scroll div {
  min-width: 30%;
}
.wrapper-scroll p {
  width: 100%;
  font-size: 30px;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: black;
  }
  60% {
    color: var(--ion-color-danger);
  }
  100% {
    color: var(--ion-color-primary);
  }
}
.text-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.text-block ion-icon {
  width: 25px !important;
  height: 25px !important;
  margin-right: 10px;
}
.text-block h5 {
  text-transform: uppercase;
  text-align: center;
  color: var(--ion-color-primary);
  animation: pulseColor 2s infinite alternate;
}
.text-block ion-icon {
  color: var(--ion-color-primary);
  animation: pulseColor 2s infinite alternate;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAOA;EACC,2BAAA;AAND;AAOC;EACC,iBAAA;EAEA,YAAA;EACA,wDAAA;EAiDA,iBAAA;AAtDF;ACDE;EDQA;IAEE,aAAA;EALF;AACF;AAOE;EACC,YAAA;EACA,YAAA;AALH;AChBE;EDmBA;IAIE,YAAA;IACA,YAAA;EAHF;AACF;AAKE;EACC,aAAA;EACA,mBAAA;AAHH;AAIG;EAIC,kBAAA;EACA,aAAA;EACA,uBAAA;AALJ;ACzBE;EDwBC;IAEE,aAAA;EAGH;AACF;AACI;EACC,sBAAA;EACA,uBAAA;AACL;AACI;EACC,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACL;AAAK;EACC,eAAA;EACA,YAAA;EACA,oCAAA;AAEN;ACnDE;EDwDA;IAEE,aAAA;EAHF;AACF;AAKE;EACC,sBAAA;EACA,uBAAA;AAHH;AAKE;EACC,aAAA;EACA,mBAAA;AAHH;AAIG;EACC,iBAAA;AAFJ;AAKE;EACC,uBAAA;EACA,uBAAA;EACA,iBAAA;AAHH;ACxEE;EDwEA;IAKE,aAAA;EADF;AACF;AAWE;EACC,aAAA;EACA,mBAAA;AATH;AAUG;EAIC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAXJ;ACxFE;ED2FC;IAEE,aAAA;EADH;AACF;AAOI;EACC,sBAAA;EACA,uBAAA;AALL;AAOI;EACC,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALL;AAMK;EACC,eAAA;EACA,YAAA;EACA,oCAAA;AAJN;AAUE;EACC,aAAA;EACA,uBAAA;EACA,cAAA;AARH;AASG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAPJ;AASG;EACC,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;AAPJ;AC3IE;ED2IC;IASE,eAAA;IACA,iBAAA;EALH;AACF;AASI;EACC,WAAA;EACA,YAAA;AAPL;ACrJE;ED0JE;IAIE,WAAA;IACA,YAAA;EALJ;AACF;AAOI;EACC,eAAA;EACA,eAAA;AALL;AC/JE;EDkKE;IAIE,eAAA;EAHJ;AACF;AAKI;EACC,eAAA;AAHL;AA4CE;EACC,mBAAA;EACA,UAAA;EAEA,wBAAA;EAAA,mBAAA;EAMA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;AAhDH;AAqCG;EACC,kBAAA;EACA,UAAA;EACA,WAAA;AAnCJ;ACxLE;EDmNA;IAmBE,uBAAA;EA1CF;AACF;AC7LE;ED2OE;IACC,eAAA;IACA,aAAA;IACA,uBAAA;IACA,6BAAA;EA3CH;AACF;AA8CG;EACC,aAAA;AA5CJ;AA8CG;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA5CJ;AC/ME;EDsPC;IAOE,aAAA;IACA,eAAA;EA1CH;EA2CG;IACC,WAAA;EAzCJ;AACF;AA+CG;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;AA7CJ;AC9NE;EDuQC;IAME,2BAAA;IAAA,sBAAA;EA3CH;AACF;AA4CI;EACC,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AA1CL;ACpPE;ED+QE;IAiBE,YAAA;IACA,eAAA;EAxCJ;EAyCI;IACC,wBAAA;IACA,4BAAA;EAvCL;AACF;AAiDI;EACC,wBAAA;AA/CL;AAgDK;EACC,UAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;AA9CN;ACvQE;EDiTG;IAME,WAAA;IACA,YAAA;EA5CL;AACF;AA6CM;EACC,WAAA;EACA,YAAA;AA3CP;ACjRE;ED0TI;IAIE,WAAA;IACA,YAAA;EAzCN;AACF;AA8CI;EACC,UAAA;EAEA,kBAAA;EACA,YAAA;EACA,iBAAA;EAGA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA/CL;ACpSE;EDqUE;IAiBE,YAAA;IACA,WAAA;EA9CJ;AACF;AA+CK;EACC,UAAA;EACA,cAAA;AA7CN;AA+CK;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AA7CN;ACtTE;ED6VG;IAQE,YAAA;IACA,WAAA;EA3CL;AACF;;AAmDA;EACC,WAAA;AAhDD;AChUE;ED+WF;IAGE,uBAAA;IACA,kBAAA;EA9CA;AACF;;AAiDA;EACC,oBAAA;AA9CD;AC1UE;EDuXF;IAGE,cAAA;IACA,oBAAA;EA5CA;AACF;;AA+CA;EACC,wBAAA;EACA,0BAAA;EACA,+CAAA;EACA,wBAAA;EACA,mCAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AA5CD;AC7VE;ED+XF;IAYE,WAAA;EA1CA;AACF;;AA6CA;EACC,YAAA;EACA,gBAAA;AA1CD;AA4CE;EACC,kBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AA1CH;;AA+CA;EACC,cAAA;EACA,YAAA;EACA,WAAA;AA5CD;;AA+CA;EACC,gBAAA;AA5CD;;AA+CA;EACC,mBAAA;AA5CD;;AA8CA;EACC,gBAAA;EACA,yBAAA;AA3CD;;AChYE;ED6aF;IAEE,aAAA;EA1CA;AACF;;AA4CA;EACC,UAAA;EACA,qBAAA;AAzCD;;AA4CA;EACC,UAAA;EACA,wBAAA;EACA,gCAAA;AAzCD;;AA4CA;EACC,kBAAA;EAIA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AA5CD;AC1ZE;ED6bF;IAGE,sBAAA;EAlCA;AACF;AAwCC;EACC,YAAA;EACA,eAAA;EACA,oCAAA;EACA,0BAAA;AAtCF;ACraE;EDucD;IAME,eAAA;IACA,qBAAA;EApCD;AACF;;AAwCA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,cArd8B;EAsd9B,cAvd0B;EAwd1B,mBAAA;EAEA,kDAAA;EACA,WAAA;EACA,SAAA;EAEA,sBAAA;AAxCD;AA0CC;EACC,QAAA;EAGA,oDAAA;AAxCF;AA2CC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,iBAAA;AAzCF;AA2CE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EAEA,6BAAA;AA3CH;AA8CE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AA5CH;AA6CG;EACC,YAAA;EACA,WAAA;AA3CJ;AAgDC;EACC,wBAAA;EACA,aAAA;AA9CF;AAgDC;EACC,WAAA;EACA,WAAA;EACA,2BAAA;AA9CF;;AAiDA;EACC,eAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,+CAAA;AA9CD;AAgDC;EACC,UAAA;EACA,iBAAA;AA9CF;;AAiDA;EACC,YAAA;AA9CD;AA+CC;EACC,YAAA;AA7CF;;AAiDA;EACC,iBAAA;EACA,kBAAA;EACA,iBAAA;AA9CD;;AAiDA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AA9CD;ACvgBE;EDkjBF;IAKE,yEAAA;IACA,YAAA;IACA,WAAA;EA5CA;AACF;AA6CE;EATF;IAUG,YAAA;EA1CD;AACF;;AA6CA;EACC,YAAA;AA1CD;;AA6CA;EACC,qBAAA;AA1CD;AC3hBE;EDokBF;IAGE,gBAAA;EAxCA;AACF;;AA0CA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,UAAA;AAvCD;;AA0CC;EACC,oBAAA;AAvCF;AC5iBE;EDklBD;IAGE,qBAAA;EArCD;AACF;;AAwCA;EACC,WAAA;EACA,aAAA;AArCD;ACtjBE;EDylBF;IAIE,kBAAA;EAnCA;AACF;AAoCC;EACC,YAAA;EACA,WAAA;EACA,8EAAA;AAlCF;AChkBE;ED+lBD;IAKE,+EAAA;IACA,YAAA;EAhCD;AACF;AAiCG;EARF;IASG,YAAA;EA9BF;AACF;;AAmCA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhCD;AAiCC;EACC,gBAAA;AA/BF;;AAkCA;EACC,iBAAA;AA/BD;;AAiCA;EACC,YAAA;AA9BD;;AAgCA;EACC,aAAA;EACA,gBAAA;AA7BD;;AA+BA;EACC,WAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EACA,aAAA;AA5BD;AA6BC;EACC,cAAA;AA3BF;AA6BC;EACC,WAAA;EACA,eAAA;AA3BF;;AA8BA;EACI;IACI,+BAAA;EA3BN;EA6BE;IACI,YAAA;EA3BN;EA6BD;IACC,8BAAA;EA3BA;EA6BE;IACI,+BAAA;EA3BN;AACF;AA8BA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AA5BD;AA6BC;EACC,sBAAA;EACA,uBAAA;EACA,kBAAA;AA3BF;AA6BC;EACC,yBAAA;EACA,kBAAA;EACA,+BAAA;EACA,2CAAA;AA3BF;AA8BC;EACC,+BAAA;EAEA,2CAAA;AA7BF","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 40%;\n$order_basket_block_max_width: 45%;\n\n\nion-header {\n\tbox-shadow: none !important;\n\t.toolbar {\n\t\tbackground: white;\n\n\t\tz-index: 999;\n\t\tbox-shadow: 0px 4px 50px 0px #0000001A;\n\n\t\t.logo_icon {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 155px;\n\t\t\theight: 50px;\n\t\t\t@include desktop {\n\t\t\t\twidth: 160px;\n\t\t\t\theight: 60px;\n\t\t\t}\n\t\t}\n\t\t.burger_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.basket_version {\n\t\t\t\t@include mobile {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 35px !important;\n\t\t\t\t\theight: 35px !important;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tright: 0px;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tbackground: white;\n\t\t.logo_icon {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t.back_icon {\n\t\t\twidth: 20px !important;\n\t\t\theight: 20px !important;\n\t\t}\n\t\t.back-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tion-icon {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t\t.desktop-logo {\n\t\t\twidth: 120px !important;\n\t\t\theight: 50px !important;\n\t\t\tmargin-left: 30px;\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t// ion-icon {\n\t\t//   width: 155px;\n\t\t//   height: 50px;\n\t\t//   @include desktop {\n\t\t//     width: 200px;\n\t\t//     height: 80px;\n\t\t//   }\n\t\t// }\n\t\t.burger_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.basket_version {\n\t\t\t\t@include mobile {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 35px;\n\t\t\t\theight: 35px;\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 35px !important;\n\t\t\t\t\theight: 35px !important;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tright: 0px;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.venue_info_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\tmax-width: 70%;\n\t\t\t.map_icon {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 25px;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tpadding: 1px 6px;\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 10px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t@include desktop {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tpadding: 3px 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.venue_info {\n\t\t\t\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 11px;\n\t\t\t\t\theight: 11px;\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\theight: 13px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .header_block_info {\n\t\t//   display: flex;\n\t\t//   align-items: center;\n\t\t//   justify-content: flex-end;\n\t\t//   .user {\n\t\t//     width: 25px;\n\t\t//     height: 25px;\n\t\t//     padding-left: 10px;\n\n\t\t//   }\n\n\t\t//   .lang_selection {\n\t\t//     display: flex;\n\t\t//     align-items: center;\n\t\t//     justify-content: center;\n\t\t//     &_item {\n\t\t//       background: white;\n\t\t//       border-radius: 28px;\n\t\t//       display: flex;\n\t\t//       align-items: center;\n\t\t//       padding: 7px 15px;\n\t\t//       ion-img {\n\t\t//         width: 20px;\n\t\t//       }\n\t\t//       p {\n\t\t//         font-size: 14px;\n\t\t//         color: var(--text-color);\n\t\t//         text-transform: uppercase;\n\t\t//         font-family: AppFontBold, sans-serif;\n\t\t//         padding-left: 5px;\n\t\t//       }\n\t\t//     }\n\t\t//   }\n\t\t// }\n\t}\n\n\t.categories-block {\n\t\t.category-list {\n\t\t\tvisibility: visible;\n\t\t\topacity: 1;\n\n\t\t\theight: fit-content;\n\t\t\t&.hide-scroll {\n\t\t\t\tvisibility: hidden;\n\t\t\t\topacity: 0;\n\t\t\t\theight: 0px;\n\t\t\t}\n\t\t\ttransition: 1s linear;\n\t\t\topacity: 1;\n\t\t\tdisplay: flex;\n\t\t\toverflow: auto;\n\t\t\tscroll-behavior: smooth;\n\t\t\t-ms-overflow-style: none;\n\t\t\tscrollbar-width: none; /* Firefox */\n\t\t\t// margin-bottom: 10px;\n\t\t\t@include desktop {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\n\t\t\t@include desktop {\n\t\t\t\t// flex-grow: 1;\n\t\t\t\t> ion-chip {\n\t\t\t\t\toverflow: unset;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-grow: 1 !important;\n\t\t\t\t\tpadding: 12px 16px !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.line-dotted-block {\n\t\t\t\tmin-width: 20px;\n\t\t\t\theight: 63px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\t@include desktop {\n\t\t\t\t\theight: 112px;\n\t\t\t\t\tmin-width: 50px;\n\t\t\t\t\tion-img {\n\t\t\t\t\t\twidth: 23px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t// .line-dotted-block:last-child {\n\t\t\t//   display: none;\n\t\t\t// }\n\t\t\t.category-wrapper {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: center;\n\t\t\t\tmin-width: fit-content;\n\t\t\t\t@include desktop {\n\t\t\t\t\tmin-width: fit-content;\n\t\t\t\t}\n\t\t\t\t.category-name {\n\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tword-break: break-word;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 1;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tmargin-top: 0px;\n\t\t\t\t\tfont-weight: 100;\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t\twidth: 60px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\tcolor: #979797;\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\twidth: 100px;\n\t\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\t\t&.selected {\n\t\t\t\t\t\t\tcolor: var(--text-color);\n\t\t\t\t\t\t\ttransition: ease-in-out 0.5s;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t// &:first-child {\n\t\t\t\t// \tmargin-left: 12px;\n\t\t\t\t// }\n\n\t\t\t\t// &:last-child {\n\t\t\t\t// \tmin-width: 100% !important;\n\t\t\t\t// }\n\t\t\t\t&.selected {\n\t\t\t\t\ttransition: 200ms linear;\n\t\t\t\t\tion-chip {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\t\theight: 80px;\n\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t@include desktop {\n\t\t\t\t\t\t\twidth: 70px;\n\t\t\t\t\t\t\theight: 70px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.border-dotted {\n\t\t\t\t\t\t\twidth: 78px;\n\t\t\t\t\t\t\theight: 78px;\n\t\t\t\t\t\t\t@include desktop {\n\t\t\t\t\t\t\t\twidth: 65px;\n\t\t\t\t\t\t\t\theight: 65px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tion-chip {\n\t\t\t\t\topacity: 1;\n\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tpadding: 5px;\n\t\t\t\t\tbackground: white;\n\n\t\t\t\t\t// transition: color 200ms linear, background 200ms linear;\n\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\tflex: 0 0 auto;\n\t\t\t\t\theight: 60px;\n\t\t\t\t\twidth: 60px;\n\t\t\t\t\tmargin: 0px;\n\t\t\t\t\tpadding: 0px;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\theight: 60px;\n\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t}\n\t\t\t\t\t.category-image {\n\t\t\t\t\t\twidth: 80%;\n\t\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\t}\n\t\t\t\t\t.border-dotted {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t\twidth: 58px;\n\t\t\t\t\t\theight: 58px;\n\t\t\t\t\t\t@include desktop {\n\t\t\t\t\t\t\theight: 55px;\n\t\t\t\t\t\t\twidth: 55px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n}\n\n.articles-wrapper {\n\tpadding: 18px 20px 0;\n\t@include desktop {\n\t\tmargin: 0 -5px;\n\t\tpadding: 20px 50px 0;\n\t}\n}\n\nion-searchbar {\n\tpadding-inline-end: 12px;\n\tpadding-inline-start: 12px;\n\t--placeholder-color: var(--ion-color-secondary);\n\t--placeholder-opacity: 1;\n\t--color: var(--ion-color-secondary);\n\t--icon-color: var(--ion-color-secondary);\n\t--border-radius: 0px;\n\tborder-radius: 10px;\n\tfont-size: 14px;\n\tfont-family: Raleway, sans-serif;\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n\tion-col {\n\t\t&.hidden {\n\t\t\tvisibility: hidden;\n\t\t\tmin-height: 0px;\n\t\t\theight: 0px;\n\t\t\ttransition: ease-out 1s;\n\t\t}\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n\n.padding-end {\n\tpadding-right: 11px;\n}\nion-footer {\n\tbackground: #fff;\n\ttext-transform: uppercase;\n}\n.footer-btn {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.search-block {\n\topacity: 1;\n\ttransition: 1s linear;\n}\n\n.hidden {\n\topacity: 0;\n\tdisplay: none !important;\n\ttransition: 1s linear !important;\n}\n\n.category-header {\n\tpadding: 20px 20px;\n\t@include desktop {\n\t\tpadding: 0px 20px 10px;\n\t}\n\ttext-transform: uppercase;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground: white;\n\th3 {\n\t\tcolor: black;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t@include desktop {\n\t\t\tfont-size: 27px;\n\t\t\tpadding: 0px 30px 0px;\n\t\t}\n\t}\n}\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 100%;\n\n\tmax-width: $order_basket_block_max_width;\n\tmin-width: $order_basket_block_width;\n\tbackground: #f6f0eb;\n\n\tbox-shadow: -4px 4px 100px 0px rgba(0, 0, 0, 0.15);\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t\tright: 0;\n\t\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 25px 20px 25px 0px;\n\t\tbackground: white;\n\n\t\t.close_basket_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tpadding-left: 20px;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\n\t\t\tcolor: var(--ion-color-black);\n\t\t}\n\n\t\t.close_basket_img_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: #d9d9d9;\n\t\t\tpadding: 0 16.5px;\n\t\t\theight: 55px;\n\t\t\twidth: 55px !important;\n\t\t\t.close_basket_img {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.order_list_row {\n\t\theight: calc(95% - 70px);\n\t\tdisplay: flex;\n\t}\n\t.checkout_row {\n\t\twidth: 100%;\n\t\theight: 50%;\n\t\tpadding: 20px 20px 0px 20px;\n\t}\n}\n.filters_section {\n\tposition: fixed;\n\tbottom: -80%;\n\tleft: 0;\n\tright: 0;\n\tbackground: white;\n\toverflow: hidden;\n\ttransition: bottom 0.6s ease-in-out;\n\tbox-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1);\n\n\t&.visible {\n\t\tbottom: 0%;\n\t\toverflow: visible;\n\t}\n}\nswiper-container {\n\theight: 100%;\n\tswiper-slide {\n\t\theight: 100%;\n\t}\n}\n\n.bg-white {\n\tbackground: white;\n\tposition: relative;\n\tpadding: 10px 0px;\n}\n\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\tbackground: url('../../../assets/losteria/separator_doted2.svg') no-repeat center center/ 100% 130%;\n\t\theight: 26px;\n\t\twidth: 100%;\n\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\nion-spinner {\n\tcolor: white;\n}\n\n.margin-block {\n\tmargin: 10px 20px 0px;\n\t@include desktop {\n\t\tmargin: 0px 40px;\n\t}\n}\n.test {\n\twidth: 100%;\n\theight: 30px;\n\tposition: absolute;\n\tbox-shadow: 0px 4px 50px 0px #0000001a;\n\ttop: -31px;\n}\n.items-wrap {\n\t&.padding-bottom {\n\t\tpadding-bottom: 120%;\n\t\t@include desktop {\n\t\t\tpadding-bottom: 400px;\n\t\t}\n\t}\n}\n.separator_white_wrapper {\n\twidth: 100%;\n\tpadding: 20px;\n\t@include desktop {\n\t\tpadding: 20px 50px;\n\t}\n\t.separator_white {\n\t\theight: 14px;\n\t\twidth: 100%;\n\t\tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 100%;\n\t\t@include desktop {\n\t\t\tbackground: url('../../../assets/losteria/separator_doted2_white.svg') no-repeat center center/ 100% 130%;\n\t\t\theight: 20px;\n\n\t\t\t@media (max-height: 750px) {\n\t\t\t\theight: 11px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.text_type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 5px;\n\tmargin-bottom: 5px;\n\tion-icon {\n\t\tmargin-left: 5px;\n\t}\n}\n.padding-block {\n\tpadding: 5px 20px;\n}\n.data-card {\n\tcolor: white;\n}\n.search-results {\n\theight: 20rem;\n\toverflow: scroll;\n}\n.wrapper-scroll {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tflex-wrap: nowrap;\n\toverflow: auto;\n\tbackground: white;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\theight: 100px;\n\tdiv {\n\t\tmin-width: 30%;\n\t}\n\tp {\n\t\twidth: 100%;\n\t\tfont-size: 30px;\n\t}\n}\n@keyframes pulseColor {\n    0% {\n        color: var(--ion-color-primary);\n    }\n    30% {\n        color: black;\n    }\n\t60% {\n\t\tcolor: var(--ion-color-danger);\n\t}\n    100% {\n        color: var(--ion-color-primary);\n\n    }\n}\n.text-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tion-icon {\n\t\twidth: 25px !important;\n\t\theight: 25px !important;\n\t\tmargin-right: 10px;\n\t}\n\th5 {\n\t\ttext-transform: uppercase;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-primary);\n\t\tanimation: pulseColor 2s infinite alternate;\n\n\t}\n\tion-icon {\n\t\tcolor: var(--ion-color-primary);\n\n\t\tanimation: pulseColor 2s infinite alternate;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
